export enum MergeTypeEnum {
    Push_Order_Only = 1,
    Replenishment_Only = 2,
    Max = 3,
}

export const MergeTypeEnumLabels = {
    [MergeTypeEnum.Push_Order_Only]: 'Push Order Only',
    [MergeTypeEnum.Replenishment_Only]: 'Replenishment Only',
    [MergeTypeEnum.Max]: 'Max',
}

export enum ShipInEnum {
    None = 1,
    Ship_In_Only = 2,
    Build_To = 3,
    Both = 4,
}

export const ShipInEnumLabels = {
    [ShipInEnum.None]: 'None',
    [ShipInEnum.Ship_In_Only]: 'Ship in Only',
    [ShipInEnum.Build_To]: 'Build To',
    [ShipInEnum.Both]: 'Both',
}